import { render, staticRenderFns } from "./LeadersMobile.vue?vue&type=template&id=0df97330&scoped=true"
import script from "./LeadersMobile.vue?vue&type=script&lang=js"
export * from "./LeadersMobile.vue?vue&type=script&lang=js"
import style0 from "./LeadersMobile.vue?vue&type=style&index=0&id=0df97330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df97330",
  null
  
)

export default component.exports